/* eslint-disable @typescript-eslint/no-explicit-any */
import MiiaFwConfig from '@/configs/config'
import { ERROR_CODES } from '@/constants/error/errorCode'
import { ERROR_MESSAGES } from '@/constants/error/errorMessage'
import { useApiGw } from '@/features/miiaFw/composables/useApiGw'
import type { ApiRequest } from '@/types/api/common/apiRequest'
import type { GetMapTilesRequestParam, ResGetMapTilesParam } from '@/types/api/mapTile/mapTileType'

export const mapTileDaoApi = () => {
  /**
   * ベースマップ取得
   * @param params リクエストパラメータ
   * @returns APIレスポンス
   */
  const getMapTiles = async (params: GetMapTilesRequestParam): Promise<ResGetMapTilesParam> => {
    const request = {
      function: 'getMapTiles',
      params
    }
    return await callGetMapTilesApi(request)
  }

  /**
   * 土砂災害警戒区域（急傾斜地の崩壊）取得
   * @param params リクエストパラメータ
   * @returns APIレスポンス
   */
  const getSlopeFailureData = async (
    params: GetMapTilesRequestParam
  ): Promise<ResGetMapTilesParam> => {
    const request = {
      function: 'getSlopeFailureData',
      params
    }
    return await callGetMapTilesApi(request)
  }

  /**
   * 土砂災害警戒区域（土石流）取得
   * @param params リクエストパラメータ
   * @returns APIレスポンス
   */
  const getDebrisFlowData = async (
    params: GetMapTilesRequestParam
  ): Promise<ResGetMapTilesParam> => {
    const request = {
      function: 'getDebrisFlowData',
      params
    }
    return await callGetMapTilesApi(request)
  }

  /**
   * 土砂災害警戒区域（地すべり）取得
   * @param params リクエストパラメータ
   * @returns APIレスポンス
   */
  const getLandslideData = async (
    params: GetMapTilesRequestParam
  ): Promise<ResGetMapTilesParam> => {
    const request = {
      function: 'getLandslideData',
      params
    }
    return await callGetMapTilesApi(request)
  }

  /**
   * 洪水浸水想定区域（想定最大規模）取得
   * @param params リクエストパラメータ
   * @returns APIレスポンス
   */
  const getFloodMaxScaleData = async (
    params: GetMapTilesRequestParam
  ): Promise<ResGetMapTilesParam> => {
    const request = {
      function: 'getFloodMaxScaleData',
      params
    }
    return await callGetMapTilesApi(request)
  }

  /**
   * 洪水浸水想定区域（計画規模）取得
   * @param params リクエストパラメータ
   * @returns APIレスポンス
   */
  const getFloodPlannedScaleData = async (
    params: GetMapTilesRequestParam
  ): Promise<ResGetMapTilesParam> => {
    const request = {
      function: 'getFloodPlannedScaleData',
      params
    }
    return await callGetMapTilesApi(request)
  }

  /**
   * 津波浸水想定区域取得
   * @param params リクエストパラメータ
   * @returns APIレスポンス
   */
  const getTsunamiInundationData = async (
    params: GetMapTilesRequestParam
  ): Promise<ResGetMapTilesParam> => {
    const request = {
      function: 'getTsunamiInundationData',
      params
    }
    return await callGetMapTilesApi(request)
  }

  /**
   * 国土地理院タイル取得APIを実行する
   * @param params リクエストパラメータ
   * @returns APIレスポンス
   */
  const callGetMapTilesApi = async (
    params: ApiRequest<GetMapTilesRequestParam>
  ): Promise<ResGetMapTilesParam> => {
    return await new Promise((resolve, reject) => {
      useApiGw().invokeApiGwFunc(
        // API Gatewayのエンドポイント
        MiiaFwConfig.config.apiGwEndpointOperation,
        // Lambda関数をコールするためのWebAPIのサブディレクトリ
        '/getMapTiles',
        // Lambda関数に渡す引数
        params,
        // Lambda関数実行前の前処理のコールバック
        () => {},
        // 成功時のコールバック
        (response: ResGetMapTilesParam) => {
          resolve(response)
        },
        // 例外受信時のコールバック(引数: エラーメッセージ)
        (message: any) => {
          reject({ message: message })
        },
        // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
        () => {
          reject({ message: ERROR_MESSAGES[ERROR_CODES.API_EXECUTION_FAILED].message })
        },
        // 処理完了後に実行するコールバック
        () => {},
        false
      )
    })
  }

  return {
    getMapTiles,
    getSlopeFailureData,
    getDebrisFlowData,
    getLandslideData,
    getFloodMaxScaleData,
    getFloodPlannedScaleData,
    getTsunamiInundationData
  }
}
